// ─── AI-POWERED INSPIRE ME ────────────────────────────────────────────────────
// Calls the Anthropic API via a secure Supabase Edge Function.
// The API key NEVER touches the browser — it lives in the edge function secret.
// Falls back to a rich local bank if the edge function is unavailable.

const EDGE_FN_URL = process.env.REACT_APP_SUPABASE_URL + '/functions/v1/ai-inspire';

const LOCAL_BANK = {
  en: [
    "You make every room brighter just by walking in.",
    "I think about your kindness more than you know.",
    "The world is genuinely better because you exist in it.",
    "You are stronger than the thing you're worried about right now.",
    "Someone out there is so glad you never gave up.",
    "Your laugh is one of the best sounds I've ever heard.",
    "You deserve every beautiful thing coming your way.",
    "I hope you're as proud of yourself as I am of you.",
    "The way you care for people is rare and so precious.",
    "You carry so much grace even when things are hard.",
    "I noticed how hard you've been working, and it shows.",
    "You have this gift of making people feel seen. Don't underestimate it.",
    "There are people whose lives are better because you're in them.",
    "You don't need to be perfect. You just need to be you.",
    "Something you said to me once changed the way I think. Thank you.",
    "You show up for others in ways that cost you — and that's beautiful.",
    "Your heart is one of the kindest I've ever known.",
    "I love the way your eyes light up when you talk about what you love.",
    "You've been through a lot. You're still standing. That matters.",
    "There's a version of you that five-year-old you would be so proud of.",
    "You notice things other people miss. That's a superpower.",
    "The patience you show when things are hard is remarkable.",
    "I've watched you grow so much this year. You should be so proud.",
    "You don't always see your own light, but it's always there.",
    "The courage it takes to just be yourself every day — I see it.",
    "You handle hard things with more dignity than you realize.",
    "There's something about your presence that puts people at ease.",
    "I hope today gives you back a little of what you give everyone else.",
    "You've made a bigger difference than you know.",
    "Whatever you're going through right now, you're not alone in it.",
  ],
  ar: [
    "بتضوّي كل مكان بس بوجودك.",
    "بفكر في لطفك أكتر مما بتتخيل.",
    "الدنيا أحسن بكتير عشان إنت فيها.",
    "أنت أقوى من اللي بيخوّفك دلوقتي.",
    "في ناس بتشكر ربنا كل يوم عشان إنت ما استسلمتش.",
    "ضحكتك من أجمل الأصوات اللي سمعتها.",
    "تستحق كل الحاجات الحلوة اللي جاية.",
    "أتمنى تبقى فخور بنفسك زي ما أنا فخور بيك.",
    "طريقتك في الاهتمام بالناس نادرة وغالية.",
    "بتحمل أياك بكل رقي حتى لما الحياة صعبة.",
    "لاحظت قد إيه بتجتهد، وهيبان.",
    "عندك موهبة إنك بتخلي الناس تحس إنهم مرئيين — متستهونش بيها.",
    "في ناس حياتها أحسن عشان إنت موجود فيها.",
    "مش محتاج تكون مثالي. بس كن إنت.",
    "قلبك من أطيب القلوب اللي عرفتها.",
    "بتقف مع الناس بطرق بتكلّفك — وده جميل.",
    "عديت على تعب كتير وبتوقف لسه. ده مهم.",
    "الشجاعة اللي بتاخدها عشان تبقى نفسك كل يوم — شايفها.",
    "في حاجة في حضورك بتريّح الناس.",
    "عملت فرق أكبر مما بتعرف.",
    "مهما كنت عاملاً فيه دلوقتي، مش لوحدك.",
    "في قوة هادية فيك بتلهمني.",
    "إنت أكتر من كافي. وكنت دايماً كده.",
  ],
};

export async function getAIInspiration(recipientName, lang = 'en') {
  try {
    const res = await fetch(EDGE_FN_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ recipientName, lang }),
    });
    if (!res.ok) throw new Error('Edge function error');
    const data = await res.json();
    if (data.text && data.text.length > 10) return data.text;
    throw new Error('Empty response');
  } catch {
    const bank = LOCAL_BANK[lang] || LOCAL_BANK.en;
    return bank[Math.floor(Math.random() * bank.length)];
  }
}

export function getLocalInspiration(lang = 'en') {
  const bank = LOCAL_BANK[lang] || LOCAL_BANK.en;
  return bank[Math.floor(Math.random() * bank.length)];
}
